<template>
  <div>
    <div class="text-center mt-6 mb-6">
      <v-img
        src="@/assets/img/gba-logox144.png"
        class="my-2"
        contain
        height="144"
      />
      <h1 class="display-2 font-weight-bold">
        Genomic Bleed Application
      </h1>
      Last Server Update: {{ lastServerLoadTime ?? 'N/A' }}
    </div>
    <v-row class="mx-1" justify="space-around">
      <v-col v-show="!userAuthorized">
        <v-card max-width="420px" color="accent">
          <v-card-title>
            Not Authorized
          </v-card-title>
          <v-card-text class="subtitle-1">
          <b>{{ (userProfile?userProfile.displayName : '') }}</b>
          is unauthorized for this application.
          </v-card-text>
        </v-card>
      </v-col>

      <v-col v-show="userAuthorized && settings.currentFarm == null">
        <v-btn
          x-large
          color="secondary"
          block
          class="white--text"
          @click="gotoSettings()"
        >
          <v-icon>mdi-cog</v-icon><div>Click here to set farm</div>
        </v-btn>
      </v-col>

      <v-col v-if="settings.currentFarm != null">
        <v-btn
          x-large
          color="tertiary"
          block
          class="white--text"
          @click="$router.push('GenomicBleed')"
        >
          <v-icon>mdi-dna</v-icon>
          <div class="pl-1 pt-1">Genomic Bleed</div>
        </v-btn>
      </v-col>

      <v-col v-if="settings.currentFarm != null && settings.isGenomicCheckEnabled">
        <v-btn
          x-large
          color="success"
          block
          @click="$router.push({ name: 'Genomic Check', params: {check: true}})"
        >
          <v-icon>mdi-check-decagram-outline</v-icon>
          <div class="pl-1 pt-1">Genomic Check</div>
        </v-btn>
      </v-col>

      <v-col v-if="settings.currentFarm">
        <v-btn
            x-large 
            color="secondary" 
            block 
            @click="$router.push('HealthBleed')">
          <v-icon>mdi-medical-bag</v-icon>
          <div class="pl-2 pt-1">Health Bleed</div>
        </v-btn>
      </v-col>
    </v-row>
    <v-overlay :value="isBusy">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import OfflineStorage from '../offlineStorage';

export default {
  data() {
    return {
      lastServerLoadTime: null,
      userAuthorized: true,
      isBusy: false
    }
  },
  computed: {
    ...mapState(['settings', 'isAuthenticated', 'isOnline', 'userProfile'])
  },
  async mounted() {
    this.lastServerLoadTime = await OfflineStorage.getItem('lastServerLoadTime');

    if (this.isOnline && this.isAuthenticated) {
      try {
        this.isBusy = true;
        
        //* Load Farm Settings from server if it has been more than 10 minutes since last load.
        const TEN_MINUTES = 10 * 60 * 1000;
        const lastLoadTime = this.lastServerLoadTime ? new Date(this.lastServerLoadTime).getTime() : 0;
        const timeDifference = new Date().getTime() - lastLoadTime;
        if (timeDifference > TEN_MINUTES) {
          console.log('Loading Farm Settings from Server...');
          await this.loadFarmSettingsFromServer({settings: this.settings, root:this.$root});
          const loadDate = new Date();

          await OfflineStorage.setItem('lastServerLoadTime', loadDate);
          //sessionStorage.setItem('lastServerLoadTime', loadDate);

          this.lastServerLoadTime = loadDate;
          console.log("Farm Settings Loaded from Server.");
        }

        this.isBusy = false;
      }
      catch (e) {
        this.isBusy = false;
        console.log(this.userProfile); // eslint-disable-line no-console
        if (e.toString().indexOf("User not authorized") !== -1) {
          this.userAuthorized = false;
        }
        else throw e;
      }
    }
  },
  methods: {
    ...mapActions(['loadFarmSettingsFromServer']),
    gotoSettings() {
      this.$router.replace({ name: 'Settings'});
    }
  }
}
</script>